export const steps = [
  {
    target: '#transfer-card-pj',
    content:
      'Estamos sempre em busca de novidades que facilitem sua vida. Por isso criamos uma nova maneira de antecipar e transferir seus ganhos!'
  },
  {
    target: '#transfer-card-pj-values',
    content:
      'Aqui você verá os valores disponíveis para antecipação ou transferência. Basta selecionar e confirmar o valor desejado e prontinho, dinheiro a caminho. ;)'
  },
  {
    target: '#menu-financial',
    content: 'Caso precise realizar uma operação mais detalhada você pode acessar a transferência tradicional aqui.'
  }
];
